import { Card } from "antd";

import { Followup } from "components/lists/followups/followup";
import { styles } from "./styles";

export const NextFollowup = (props) => {
  const { followup } = props;

  if (!followup) {
    return null;
  }

  return (
    <div style={styles.infoCard.container}>
      <div style={{ marginBottom: "8px" }}>
        <strong style={styles.infoCard.title}>Next Followup</strong>
      </div>
      <Card style={styles.infoCard.body}>
        <Followup hideOpportunity followup={followup} />
      </Card>
    </div>
  );
};
